import React, { Component, createRef } from 'react'
import { safeParse } from '../utils';
const Parser = safeParse;
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'

// Импорт стилей Swiper
import 'swiper/css'
import 'swiper/css/navigation'

class App extends Component {
  constructor(props) {
    super(props)
    this.swiperRef = createRef()
    this.state = {
      isBeginning: true,
      isEnd: false,
      lightboxOpen: false,
      currentImageIndex: 0
    }
  }

  handleSlideChange = (swiper) => {
    this.setState({
      isBeginning: swiper.isBeginning,
      isEnd: swiper.isEnd
    })
  }

  // Открыть документ: если у элемента есть PDF — открываем его в новой вкладке,
  // иначе показываем картинку в lightbox
  openItem = (item, index) => {
    if (item?.file) {
      window.open(item.file, '_blank', 'noopener,noreferrer')
      return
    }
    this.openLightbox(index)
  }

  // Открыть lightbox с выбранным изображением
  openLightbox = (index) => {
    this.setState({
      lightboxOpen: true,
      currentImageIndex: index
    })
    // Блокируем прокрутку страницы
    document.body.style.overflow = 'hidden'
  }

  // Закрыть lightbox
  closeLightbox = () => {
    this.setState({
      lightboxOpen: false
    })
    // Возвращаем прокрутку страницы
    document.body.style.overflow = 'auto'
  }

  // Переключение на следующее изображение
  nextImage = () => {
    const { documentation } = this.props.data
    const { currentImageIndex } = this.state
    
    if (documentation?.items && currentImageIndex < documentation.items.length - 1) {
      this.setState({
        currentImageIndex: currentImageIndex + 1
      })
    }
  }

  // Переключение на предыдущее изображение
  prevImage = () => {
    const { currentImageIndex } = this.state
    
    if (currentImageIndex > 0) {
      this.setState({
        currentImageIndex: currentImageIndex - 1
      })
    }
  }

  // Обработка нажатия клавиш
  handleKeyDown = (e) => {
    if (!this.state.lightboxOpen) return
    
    if (e.key === 'Escape') {
      this.closeLightbox()
    } else if (e.key === 'ArrowRight') {
      this.nextImage()
    } else if (e.key === 'ArrowLeft') {
      this.prevImage()
    }
  }

  componentDidMount() {
    // Добавляем обработчик клавиш
    window.addEventListener('keydown', this.handleKeyDown)
  }

  componentWillUnmount() {
    // Удаляем обработчик клавиш и возвращаем прокрутку
    window.removeEventListener('keydown', this.handleKeyDown)
    document.body.style.overflow = 'auto'
  }

  render() {
    const data = this.props?.data || {}
    const documentation = data?.documentation || {}
    const { isBeginning, isEnd, lightboxOpen, currentImageIndex } = this.state

    if (!documentation || !documentation.items) {
      return null
    }

    const images = documentation.items
    const currentImage = images[currentImageIndex]

    return (
      <>
        <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
          <div className='container'>
            <div className='flex justify-center xl:justify-start items-center gap-[10px] text-[14px] xl:text-[16px]'>
              <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.75 5.25V12.75C15.75 15 14.625 16.5 12 16.5H6C3.375 16.5 2.25 15 2.25 12.75V5.25C2.25 3 3.375 1.5 6 1.5H12C14.625 1.5 15.75 3 15.75 5.25Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10.875 3.375V4.875C10.875 5.7 11.55 6.375 12.375 6.375H13.875" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6 9.75H9" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6 12.75H12" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div className='tracking-[-0.04em] text-[#032432]/60'>Документация</div>
              </div>
            </div>
            
            <div className='flex items-end justify-between gap-[20px]'>
              <div>
                <h2 className='font-medium mt-[20px] xl:mt-[30px] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{Parser(documentation?.title)}</h2>
                <div className='mt-[10px] text-[14px] xl:text-[16px] text-center xl:text-start text-black/60'>{Parser(documentation?.text)}</div>
              </div>
              
              {/* Кастомная навигация */}
              <div className='hidden xl:flex items-center gap-[5px]'>
                {/*
                <div 
                  className={`w-[38px] h-[38px] rounded-full bg-[#032432] cursor-pointer flex items-center justify-center transition-opacity duration-300 ${
                    isBeginning ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-opacity-80'
                  }`}
                  onClick={() => !isBeginning && this.swiperRef.current?.slidePrev()}
                >
                  <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.75269 0.25L0.577271 5.75L3.75269 11.25" stroke="white"/>
                  </svg>
                </div>
                <div 
                  className={`w-[38px] h-[38px] rounded-full bg-[#032432] cursor-pointer flex items-center justify-center transition-opacity duration-300 ${
                    isEnd ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-opacity-80'
                  }`}
                  onClick={() => !isEnd && this.swiperRef.current?.slideNext()}
                >
                  <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.433105 0.25L3.60852 5.75L0.433105 11.25" stroke="white"/>
                  </svg>
                </div>
                */}
              </div>
            </div>

            {/* Слайдер с документами */}
            {/*
            <div className='hidden xl:block'>
              <Swiper
                onSwiper={(swiper) => {
                  this.swiperRef.current = swiper
                  this.handleSlideChange(swiper)
                }}
                onSlideChange={this.handleSlideChange}
                modules={[Navigation]}
                spaceBetween={20}
                slidesPerView={4}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 10
                  },
                  480: {
                    slidesPerView: 2,
                    spaceBetween: 15
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 15
                  },
                  1024: {
                    slidesPerView: 4,
                    spaceBetween: 20
                  }
                }}
                className='documentation-slider'
              >
                {documentation.items.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className='py-[20px]'>
                      <div 
                        className='rounded-[15px] xl:min-h-[504px] bg-[#F5F7F9] p-[5px] cursor-pointer transition-transform hover:scale-105 duration-300 h-full flex flex-col'
                        onClick={() => this.openLightbox(index)}
                      >
                        <img 
                          src={item.image} 
                          alt={item.name || `Документ ${index + 1}`} 
                          className='w-full h-auto rounded-[15px] object-cover'
                          loading="lazy"
                        />
                        <div className='px-[15px] py-[20px] flex-1'>
                          <div className='text-[#032432] text-[18px]'>{item.name}</div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            */}
            <div className='mt-[20px] hidden xl:grid grid-cols-4 gap-[10px] w-full'>
              {documentation.items.map((item, index) => (
                <div 
                  key={index}
                  className='rounded-[15px] bg-[#F5F7F9] p-[5px] cursor-pointer flex flex-col flex-none'
                  onClick={() => this.openItem(item, index)}
                >
                  <div className='rounded-[15px] xl:min-h-[504px] bg-[#F5F7F9] p-[5px] h-full flex flex-col relative'>
                    <img 
                      src={item.image} 
                      alt={item.name || `Документ ${index + 1}`} 
                      className='w-full h-auto rounded-[15px] object-cover'
                      loading="lazy"
                    />
                    {item.file && (
                      <div className='absolute top-[15px] right-[15px] px-[10px] h-[26px] flex items-center rounded-full bg-[#009EE3] text-white text-[12px] tracking-normal'>PDF</div>
                    )}
                    <div className='px-[15px] py-[20px] flex-1'>
                      <div className='text-[#032432] text-[18px]'>{item.name}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className='mt-[20px] flex xl:hidden gap-[10px] w-[calc(100%)+10px] overflow-x-auto overflow-y-hidden pb-[10px]'>
              {documentation.items.map((item, index) => (
                <div 
                  key={index}
                  className='rounded-[15px] bg-[#F5F7F9] p-[5px] cursor-pointer flex flex-col w-[230px] flex-none'
                  onClick={() => this.openItem(item, index)}
                >
                  <div className='relative'>
                    <img 
                      src={item.image} 
                      alt={item.name || `Документ ${index + 1}`} 
                      className='w-full h-auto rounded-[15px] object-cover'
                      loading="lazy"
                    />
                    {item.file && (
                      <div className='absolute top-[10px] right-[10px] px-[10px] h-[24px] flex items-center rounded-full bg-[#009EE3] text-white text-[12px] tracking-normal'>PDF</div>
                    )}
                  </div>
                  <div className='px-[10px] py-[15px] flex-1'>
                    <div className='text-[#032432] text-[16px]'>{item.name}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Lightbox для увеличения документа */}
        {lightboxOpen && (
          <div 
            className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90'
            onClick={this.closeLightbox}
          >
            {/* Кнопка закрытия */}
            <button 
              className='absolute top-5 right-5 text-white text-4xl hover:text-gray-300 z-10'
              onClick={this.closeLightbox}
            >
              ×
            </button>

            {/* Кнопка предыдущего изображения */}
            {currentImageIndex > 0 && (
              <button 
                className='absolute left-5 top-1/2 -translate-y-1/2 text-white text-5xl hover:text-gray-300 z-10'
                onClick={(e) => {
                  e.stopPropagation()
                  this.prevImage()
                }}
              >
                ‹
              </button>
            )}

            {/* Изображение */}
            <div 
              className='relative max-w-[90vw] max-h-[90vh] rounded-[15px] overflow-hidden'
              onClick={(e) => e.stopPropagation()}
            >
              <img 
                src={currentImage?.image} 
                alt={currentImage?.name || 'Увеличенный документ'}
                className='max-w-full max-h-[90vh] object-contain'
              />

              {/* Ссылка на PDF, если у документа есть файл */}
              {currentImage?.file && (
                <a
                  href={currentImage.file}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='absolute top-5 left-5 px-[20px] h-[38px] flex items-center rounded-full bg-[#009EE3] text-white text-[14px] z-10'
                  onClick={(e) => e.stopPropagation()}
                >
                  Открыть PDF
                </a>
              )}
              
              {/* Название документа и счетчик */}
              <div className='absolute bottom-5 left-1/2 -translate-x-1/2 text-white bg-black bg-opacity-70 px-4 py-2 rounded-full text-sm flex gap-4'>
                <span>{currentImage?.name}</span>
                <span className='text-gray-300'>{currentImageIndex + 1} / {images.length}</span>
              </div>
            </div>

            {/* Кнопка следующего изображения */}
            {currentImageIndex < images.length - 1 && (
              <button 
                className='absolute right-5 top-1/2 -translate-y-1/2 text-white text-5xl hover:text-gray-300 z-10'
                onClick={(e) => {
                  e.stopPropagation()
                  this.nextImage()
                }}
              >
                ›
              </button>
            )}
          </div>
        )}
      </>
    );
  }
}

export default App